/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TrademarkBarChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  console.log("test data chart treadmark --------------->", data);
  

  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: 'Trademarks',
        data: data.map((item) => item.value),
        backgroundColor: '#2f78c4',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: { display: false },
    },
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', height: '230px' }}>
        <Bar data={chartData} options={options} />
    </div>
  );
};

export default TrademarkBarChart;
